import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import "./Heading.scss";

const Heading = ({ title, brif, alignCenter, value, valueBrief }) => {
  const { t } = useTranslation();
  let headingBrif;

  if (brif) {
    headingBrif = (
      <Card.Text
        className={`heading-brif ${
          alignCenter || alignCenter === undefined
            ? "text-center"
            : "heading-brif-align"
        }`}
      >
        {typeof brif === "string" ? t(brif, { value }) : brif}
      </Card.Text>
    );
  }

  return (
    <Card.Body className="heading-title-wrapper">
      <Card.Title
        as="h3"
        className={`heading-title ${
          alignCenter || alignCenter === undefined
            ? "text-center"
            : "heading-title-align"
        }`}
      >
        {t(title, { value })}
      </Card.Title>
      {headingBrif}
    </Card.Body>
  );
};

Heading.propTypes = {
  title: PropTypes.string.isRequired,
  brif: PropTypes.string,
  alignCenter: PropTypes.bool,
  value: PropTypes.string,
  valueBrief: PropTypes.string,
};

export default Heading;
